import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import {standardNumberFormat} from '../../objects/CommonUse/double_functions';
import {reformatDateToDisplay} from '../../objects/CommonUse/reformatDateToDisplay_function';
import { setHeadersForFetch } from '../../objects/CommonUse/set_headers_for_fetch';
import { calculateMoodRetirementScores } from './objects/calculate_mood_retirement_scores';
import FourColumnTableCard from './four_column_table_card';
import WaitTimeSpinner from '../shared-components/wait_time_spinner';
import {buildUrl } from '../../objects/CommonUse/build_URL';
import Config from '../../config';
import ConfigFile from '../../datasets/config_file';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    gameData: state.gameData,
    savingsInfo: state.savingsInfo,
    timeWizardInfo: state.timeWizardInfo,
    summaryInvestment: state.summaryInvestment,
    // add other Redux state slices here if needed
});

class LeaderBoardModal extends Component {
            constructor(props) {
              super(props);
              this.state={
                headers: setHeadersForFetch(),
                leaderBoardLoaded: false,
                subProcess: "leaderBoard",
                environment: Config.dataURL.currentEnv,
            };  
        this.leaderData = null; 
        this.processingDoneSw = false;
        this.displayLeaderBoard = [];
        this.currentCash = 0;
        this.startGameDate = "";
        this.insertSpot = 10;
        this.currentUser = {user: "", startGameDate: "", moodScore: "",
                    retirementScore: "", combinedScore: ""};
        this.getLeaderBoardData();
        this.updateLeaderBoard = false;
     
    }

    processLeaderBoard(){
        if (this.props.accountNbr ===  "game"){
             this.classLit = "";
             this.getCurrentGameData();
             this.insertCurrentGameIntoLeaderBoardList();
        }else{
             this.classLit = "- Your Students";
             this.displayLeaderBoard = JSON.parse(JSON.stringify(this.leaderBoardData));
        }
        if (this.props.finishType ===  "fullGame" || 
            this.props.finishType ===  "forceEnd"){
            this.finishGameLit = "End of Game - "
                if (+this.insertSpot < 10){
                    this.determineIfScoreAddedToLeaderBoard();
                }                    
        }
        if (this._isMounted === true){
             this.processingDoneSw = true;
        }
    }

    getCurrentGameData() {
        let currentUser = this.props.gameData.user;
        this.currentCash = this.props.gameData.currentCash;
        this.startGameDate = this.props.gameData.startGameDate;
        let savingsAmt = 0;
        if (this.props.savingsInfo &&
            this.props.savingsInfo.totalSavingsAmt){
            savingsAmt = this.props.savingsInfo.totalSavingsAmt;
        }
        let totalNbrGameMonths = ConfigFile.gameStartItems.totalNbrGameMonths;
        if (this.props.timeWizardInfo.gameID  &&
            this.props.timeWizardInfo.status !==  "inactive"){
                totalNbrGameMonths = (+this.props.timeWizardInfo.gameNbrYears * 12);
            }
        let totalInvestments = 0;
        if (this.props.summaryInvestment.length > 0){
            const summaryInvestments = this.props.summaryInvestment;
            totalInvestments = summaryInvestments.find(elem => elem.investType === "all").currentValue;
        }
        this.scoreObj = calculateMoodRetirementScores(this.props.gameData.currentMoodPoints,
            this.currentCash, savingsAmt, totalInvestments, this.props.gameData.assetTable,
            this.props.gameData.currentGameDate);
        this.currentUser = {user: currentUser, startGameDate: this.props.gameData.startGameDate, 
            moodScore: this.scoreObj.moodScore,
            retirementScore: this.scoreObj.retirementScore, combinedScore: this.scoreObj.combinedScore,
            };
        
    }
    
    insertCurrentGameIntoLeaderBoardList() {
        this.displayLeaderBoard = JSON.parse(JSON.stringify(this.leaderBoardData));

        this.insertSpot = this.displayLeaderBoard.length;
        for (let i=0; i<this.displayLeaderBoard.length; i++){
            if (+this.currentUser.combinedScore > +this.displayLeaderBoard[i].combinedScore){
                this.insertSpot = i;
                break;
            }
        }
        if (this.insertSpot <= this.displayLeaderBoard.length){
            // insert the current game into the spot where score is less than score on leaderBoard
            if (this.insertSpot ===  this.displayLeaderBoard.length){
                this.displayLeaderBoard.push(this.currentUser);
            }else{
                this.displayLeaderBoard.splice(this.insertSpot, 0, this.currentUser);
            }
            if (this.displayLeaderBoard.length > this.nbrEntries){
                this.leaderBoardData.pop();
            }
        }
           
     }

    determineIfScoreAddedToLeaderBoard(){
        if (this.props.finishType === "fullGame"){
            this.message1 = "Congratulations!"
            this.message2 = "You will be added to the leader board."
            this.updateLeaderBoard = true;
        }else{
            this.message1 = ""
            this.message2 = "You did very well!  But, your score will not be added to the leader board " +
                "because you ended the game before the full number of years."
            this.updateLeaderBoard = false;
        }
    }

    render() {
        if (this.state.leaderBoardLoaded === true && this.processingDoneSw === false){
            this.processLeaderBoard();
        }
        this.leaderBoardList = this.displayLeaderBoard.map((scores,index) =>
            <FourColumnTableCard key={index} tableInfo={scores} 
            accountNbr={this.props.accountNbr} currentUser={this.currentUser.user}/>
            );  
        
    return <>
      {!this.processingDoneSw ?  
            <WaitTimeSpinner />
      :   
      <Modal show={this.props.modalOpen}  onHide={() => this.props.onClose()} size="md" scrollable="true"
        animation={false} contentClassName="modal-black-border" >
            <Modal.Header className="leaderboardTopBottom make-text-grey " closeButton >
            <Modal.Title>
                <div >{this.finishGameLit} Leader Board {this.classLit}</div>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="leaderboardBackground2">
            <span className="width-100">
            <table className="width-100 m-0">
                      
                {this.props.accountNbr === "game" ?
                    <thead className="make-text-grey">
                        <tr >
                            <th className="p-0 text-left" scope="col">Name</th>
                            <th className="p-0 text-center" scope="col">Game Date</th>
                            <th className="p-0 text-center" scope="col">Mood Score</th>
                            <th className="p-0 text-center" scope="col">Retirement Score</th>
                            <th className="p-0 text-right" scope="col">Combined Score</th>
                        </tr>
                    </thead>
                :
                    <thead className="make-text-grey">
                        <tr >
                            <th className="p-0 text-left" scope="col">Name</th>
                            <th className="p-0 text-center" scope="col">Nbr Game Months</th>
                            <th className="p-0 text-center" scope="col">Mood Score</th>
                            <th className="p-0 text-center" scope="col">Retirement Score</th>
                            <th className="p-0 text-right" scope="col">Combined Score</th>
                        </tr>
                    </thead>
                }
                <tbody className="leaderboardContent">
                        {this.leaderBoardList}
                </tbody> 
                {this.props.accountNbr === "game" ?
                <tbody>
                        <tr className="mt-4 make-text-grey">
                            <th className="text-center font-weight-bold" colSpan="5">
                                Your Current Game</th>
                        </tr>
                        <tr className="leaderboardContent make-text-gold">
                            <th className="p-0" scope="row">{this.currentUser.user}</th>
                            <th className="p-0 text-center">
                                {reformatDateToDisplay(this.currentUser.startGameDate)}</th>
                            <th className="text-right p-0">{standardNumberFormat(this.currentUser.moodScore)}</th>
                            <th className="text-right p-0">{standardNumberFormat(this.currentUser.retirementScore)}</th>
                            <th className="text-right p-0">{standardNumberFormat(this.currentUser.combinedScore)}</th>
                        </tr>
                    </tbody>
                :
                    null
                }
            </table>
            </span>
        </Modal.Body>
        <Modal.Footer className="p-0 leaderboardTopBottom">
            <span className="font-weight-bold">
                <div className="text-denter">{this.message1}</div>
                <div className="mx-4">{this.message2}</div>
            </span>
            <Button variant="secondary"  onClick={() => this.props.onClose(this.updateLeaderBoard)}>
                      Close
            </Button>
        </Modal.Footer>
        </Modal>
       }
        </>
    }

    
    componentDidMount(){
        this._isMounted = true;
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    getLeaderBoardData() {
        // the following ensures that leaderboard is initialized before doing fetch
        this.leaderBoardData = [];
        this.leaderBoardData.splice(0,this.leaderBoardData.length)
        if (this.props.accountNbr === "game"){
             this.nbrEntries = 10;
        }else{
             this.nbrEntries = 999;
        }
        const funcName = "leaderBoardList";
        const urlParm = "?nbrEntries=" + this.nbrEntries + "&accountNbr=" + this.props.accountNbr;
        const uri = buildUrl(this.state.environment, funcName, urlParm);
        fetch (uri,  
            {method:'GET', headers: this.state.headers})
        .then(response => {
            if (response.ok){
                response.json().then(data => {
                    const output = JSON.parse(data);
                    const statusCode = output.statusCode;
                    if (statusCode === 200){
                        this.leaderBoardData = output.body;
                        if (this._isMounted === true){
                            this.setState({leaderBoardLoaded: true});
                        }
                    }else{
                        const errorObj={function: funcName, subProcess: this.state.subProcess, 
                            status: statusCode, message: output.body.message};
                        this.props.processError(errorObj);
                    }
                });
            };
        });
      
    }
}

export default connect(mapStateToProps)(LeaderBoardModal);